import { LazyLoader } from './LazyLoader';

const lazyLoader = new LazyLoader();

export { lazyLoader };
